<template>
    <div class="travellingDiary">
        <div class="travellingDiary__topBanner">
            <travel-notes-swiper :list="banner"></travel-notes-swiper>
            <div class="topBanner__title">
                <p>{{articlePartView.title}}</p>
            </div>
            <div class="topBanner__title_shadow"></div>
        </div>
        <div class="travellingDiary__introduction">
            <div class="container">
                <div class="travellingDiary__travellInfo">
                    <div class="travellInfo--leftCon">
                        <img v-if="articlePartView.authorHeadImg" :src="articlePartView.authorHeadImg">
                        <img v-else src="https://resource.rcclchina.com.cn/logo/PC/logoAvatarCircleBlueLarge.png">
                    </div>
                    <div class="travellInfo--RightCon">
                        <div class="travellInfo--name">
                            <p class="travellingDiary--txtGray">作者：<span class="travellInfo--nickName">{{articlePartView.author}}</span></p>
                        </div>
                        <div class="travellInfo--mainCon">
                            <div class="travellInfo--item travellInfo--clock">
                                <img src="../../assets/clockIcon.png">
                                <span class="travellingDiary--txtGray">发布时间：</span>
                                <span class="travellInfo--clockTxt">{{articlePartView.updatedTime}}</span>
                            </div>
                            <div class="travellInfo--item travellInfo--ship">
                                <img src="../../assets/shipLogo.png">
                                <span class="travellingDiary--txtGray">乘坐游轮：</span>
                                <router-link class="travellInfo--shipTxt" v-if="hasShipPage"
                                :to="`/content/taste/ships/${articlePartView.shipCode}`">
                                    {{articlePartView.shipName}}
                                </router-link>
                                <span class="travellInfo--shipTxt" v-else>{{articlePartView.shipName}}</span>
                            </div>
                            <div class="travellInfo--item travellInfo--date">
                                <img src="../../assets/dateIcon.png">
                                <span class="travellingDiary--txtGray">出行时间：</span>
                                <span class="travellInfo--dateTxt">{{(articlePartView.sailDate ? articlePartView.sailDate.split('-').join('.'): "")}}</span>
                            </div>
                            <div class="travellInfo--item travellInfo--days">
                                <img src="../../assets/daysIcon.png">
                                <span class="travellingDiary--txtGray">晚数：</span>
                                <span class="travellInfo--daysTxt">{{parseInt(articlePartView.sailNights) + 1}}天{{articlePartView.sailNights}}晚</span>
                            </div>
                            <div class="travellInfo--item travellInfo--location">
                                <img src="../../assets/addressIcon.png">
                                <span class="travellingDiary--txtGray">行程：</span>
                                <span class="travellInfo--locationTxt">{{articlePartView.route}}</span>
                            </div>
                        </div>
                        <div class="travellInfo--sorts">
                            <div v-for="(item, index) in tags" :key="index" class="item--sorts">{{item}}</div>
                        </div>
                    </div>
                </div>
                <div class="travellingDiary__divideLine"></div>
            </div>
        </div>

        <div
            class="travelRoutine"
            v-bind:class="{onTop: isOnTop}"
            @mouseover="handleMouseover"
            @mouseleave="handleMouseleave"
        >
            <div class="container">
                <div class="travellingDiary__outline">
                    <div class="outline--leftCon">
                        <div v-if="!dailyActive" class="outline--leftPic">
                            <img src="../../assets/travellOutline.png">
                        </div>
                        <p class="outline--leftTitle">行程概要</p>
                    </div>
                    <div class="outline--arrowPic">
                        <img src="../../assets/arrow.png">
                    </div>
                    <travel-notes-daily
                        v-if="reviewDaily&&reviewDaily.length>0"
                        :dataList="reviewDaily"
                        :active="dailyActive"
                        :activeDay="activeDay"
                        @on-slide-to="handleSlide"
                    ></travel-notes-daily>
                </div>
            </div>
        </div>

        <div class="travellingDiary__mainContent">
            <div class="container">
                <div class="item--content">
                    <div class="item--title">
                        <p>写在最前</p>
                    </div>
                    <div class="item--divideLine"></div>
                    <div class="item--body" v-html="articlePartView.beforeText"></div>
                </div>

                <div v-for="item in reviewDaily" :key="item.day" class="item--content" v-bind:class="`item--content--${item.day}`">
                    <div class="item--title">
                        <p>{{item.dayTitle}} {{item.title}}</p>
                    </div>
                    <div class="item--divideLine"></div>
                    <div class="item--body" v-html="item.content"></div>
                </div>
                <div class="praiseCon">
                    <div class="praiseOpe" @click="upVote">
                        <img src="https://resource.rcclchina.com.cn/Review/page/%E6%B8%B8%E8%AE%B0%E7%82%B9%E8%B5%9E%E5%9B%BE%E6%A0%87.png" class="praisePicBtn grey-icon">
                        <img src="https://resource.rcclchina.com.cn/Review/page/%E6%B8%B8%E8%AE%B0%E7%82%B9%E8%B5%9E%E5%9B%BE%E6%A0%87-%E6%82%AC%E5%81%9C.png" class="praisePicBtn cur-icon">
                    </div>
                    <p class="praiseNumber">{{articlePartView.score}}</p>
                    <p class="praiseTxt">人给这篇文章点赞</p>
                </div>
                <!--列表-->
                <div class="item--listMenu">
                    <div class="item--preDiray">
                        <div v-if="preArticlePartView">
                            <img src="../../assets/preArrow.png">
                            <span class="item--txt">上一篇:</span>
                            <a class="item--dirayName"
                                :href="`/Rccl.Review/Travel/d-${this.countryName == '' ? 'n':this.countryName}-${this.shipName==''?'n':this.shipName}-${this.orderBy}-${this.offset-1}-${preArticlePartView.id}.html`"
                                :title="preArticlePartView.title">{{preArticlePartView.title}}</a>
                        </div>
                    </div>
                    <div class="item--listDiray">
                        <img src="../../assets/listMenu.png"> &nbsp;
                        <router-link class="item--returnList" to="/Rccl.Review/Travel/tn-n-n-0-0-9.html">返回列表</router-link>
                    </div>
                    <div class="item--nextDiray">
                        <div v-if="nextArticlePartView">
                            <span class="item--txt">下一篇:</span>
                            <a class="item--dirayName"
                            :href="`/Rccl.Review/Travel/d-${this.countryName == '' ? 'n':this.countryName}-${this.shipName==''?'n':this.shipName}-${this.orderBy}-${this.offset+1}-${nextArticlePartView.id}.html`"
                            :title="nextArticlePartView.title">{{nextArticlePartView.title}}</a>
                            <img src="../../assets/nextArrow.png">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- share -->
        <share-travel-note
            :isShow="isShowShare"
            :qrCode="qrCode"
            :shareUrl="shareUrl"
            :shareTitle="articlePartView.title"
            :shareText="shareText"
            :shareDesc="shareDesc"
            :shareImage="shareImage"
        ></share-travel-note>
    </div>
</template>

<script>
    import api from '@/api'
    import TravelNotesSwiper from './TravelNotesSwiper'
    import TravelNotesDaily from './TravelNotesDaily'
    import ShareTravelNote from './ShareTravelNote'
    import { delayDev } from '@/utilities/tools'

    export default {
        name: 'TravelNotesInfo',
        components: {
            TravelNotesSwiper,
            TravelNotesDaily,
            ShareTravelNote,
        },
        data: () => {
            return {
                token: '',
                travelId: '',
                banner: [],
                articlePartView: {},
                tags: [],
                nextArticlePartView: {},
                preArticlePartView: {},
                countryName: '',
                shipName: '',
                orderBy: 0,
                offset: 0,
                qrCode: '',
                reviewDaily: [],
                isOnTop: false,
                dailyActive: false,
                activeDay: 0,
                dayItemTops: [],
                dailyOffsetTop: '',
                endTop: '',
                isShowShare: false,
                shareUrl: '',
                shareText: '精彩游轮游记，尽在皇家加勒比游轮官网。游轮心得、特色餐饮、船上娱乐、岸上观光等实用信息一网打尽',
                shareDesc: '我刚刚在@皇家加勒比游轮 发现一篇#精彩游轮游记#还不赶快去看看',
                shareImage: 'https://resource.rcclchina.com.cn/Review/share.jpg',
            }
        },
        beforeMount () {
            this.init()
        },
        beforeDestroy () {
            window.removeEventListener('scroll', this.handleScroll)
        },
        methods: {
            async init () {
                await this.initPage()
            },
            async initPage () {
                this.token = this.$store.state.user.userToken
                this.travelId = this.$route.params.id
                const params = this.$route.params
                this.countryName = params.countryName === 'n' ? '' : params.countryName
                this.shipName = params.shipName === 'n' ? '' : params.shipName
                this.orderBy = parseInt(params.orderBy)
                this.offset = parseInt(params.offset)

                const data = await this.getTravelNoteDetail()

                //初始化数据
                this.banner = data.banners
                this.articlePartView = data.articlePartView
                this.tags = this.articlePartView.tags.split(',')
                this.nextArticlePartView = data.nextArticlePartView
                this.preArticlePartView = data.preArticlePartView
                this.qrCode = data.qrCode
                this.reviewDaily = data.reviewDailyTripPartRecordApiViewModels

                this.shareUrl = window.location.href

                delayDev(200, ()=> {
                    this.dayItemTops = this.getOffsetTop(this.reviewDaily)
                    this.dailyOffsetTop = document.querySelector('.travelRoutine').offsetTop
                    this.endTop = document.querySelector('.praiseCon').offsetTop
                    window.addEventListener('scroll', this.handleScroll)

                    // 初始化页面
                    this.goTop()
                })
            },
            goTop () {
                window.scrollTo({
                    top: 0
                })
            },
            handleMouseover () {
                this.dailyActive = false
            },
            handleMouseleave () {
                if (this.isOnTop) {
                    this.dailyActive = true
                }
            },
            handleSlide (day) {
                const toPose = this.dayItemTops.find(item => item.day === day)
                window.scroll({
                    top: toPose.top,
                    behavior: 'smooth'
                })
            },
            getOffsetTop (list) {
                let result = []
                list.map(item => {
                    let $ele = document.querySelector(`.item--content--${item.day}`)
                    let top = $ele.offsetTop
                    // 减去容差值
                    top = top - 10
                    result.push({
                        top,
                        day: item.day
                    })
                })
                return result
            },
            handleScroll (e) {
                let scrollTop = e.target.scrollingElement.scrollTop
                this.dayItemTops = this.getOffsetTop(this.reviewDaily)
                this.dailyOffsetTop = document.querySelector('.travelRoutine').offsetTop
                this.endTop = document.querySelector('.praiseCon').offsetTop

                this.dailyActive = scrollTop > this.dailyOffsetTop && scrollTop < this.endTop
                this.isOnTop = this.dailyActive
                if (scrollTop > 100) this.isShowShare = true
                else this.isShowShare = false
                if (scrollTop < this.dayItemTops[0].top) this.activeDay = 0
                this.dayItemTops.map((item, index, element) => {
                    if (index + 1 < element.length && scrollTop > item.top - 1 && scrollTop < element[index + 1].top) {
                        this.activeDay = item.day
                    }
                    if (index + 1 === element.length &&  scrollTop > item.top - 1) {
                        this.activeDay = item.day
                    }
                })
            },
            async upVote () {
                if (!this.token) {
                    this.$alert.show('请先登录')
                    return false
                }
                this.$loading.show()
                const {success, errMsg} = await api.review.upvote({
                    articalId: this.travelId
                })
                if (!success) {
                    this.$alert.show(errMsg)
                } else {
                    this.$alert.show('点赞成功！')
                    this.articlePartView.score++
                }
                this.$loading.hide()
            },
            async getTravelNoteDetail () {
                this.$loading.show()
                const {success, data, errMsg} = await api.review.getTravelNoteDetail({
                    countryName: this.countryName,
                    shipName: this.shipName,
                    orderBy: this.orderBy,
                    offset: this.offset,
                    travelId: this.travelId
                })
                this.$loading.hide()
                if (!success) {
                    this.$alert.show(errMsg)
                } else {
                    return data
                }
            },
        },
        computed: {
            hasShipPage () {
                let ships = ['SC', 'QN', 'VY', 'MA', 'OV']
                return this.articlePartView && ships.indexOf(this.articlePartView.shipCode)>=0
            }
        }
    }
</script>

<style scoped>
    /******** 头部banner ********/
    .travellingDiary__topBanner{
        width:100%;
        background: #fff;
        position: relative;
    }
    .topBanner__title{
        width: 100%;
        position: absolute;
        bottom: 36px;
        text-align: center;
        z-index: 3;
    }
    .topBanner__title p{
        margin: 0;
        color: #fff;
        font-size: 32px;
    }
    .topBanner__title_shadow{
        position:absolute;
        bottom:0;
        left:0;
        width:100%;
        height:125px;
        background:rgba(0,0,0,.5);
        z-index: 2;
    }

    /******** 航程概要信息 ********/
    .travellingDiary__introduction{
        width:100%;
        background: #fff;
    }
    .travellingDiary__travellInfo{
        width:100%;
        min-width: 970px;
        padding-top: 30px;
        overflow: hidden;
    }
    .travellInfo--leftCon{
        float: left;
        width:88px;
        height:88px;
    }
    .travellInfo--leftCon > img {
      width: 100%;
    }
    .travellInfo--RightCon{
        width:86%;
        float: left;
        margin-left:30px;
    }
    .travellInfo--name{
    }
    .travellInfo--nickName{
        color:#000f57;
    }
    .travellInfo--mainCon{
        clear: both;
        overflow: hidden;
        color: #999;
    }
    .travellInfo--item{
        display: inline-block;
        margin-right: 20px;
    }
    .travellInfo--item img{
        display: inline-block;
        vertical-align: middle;
        margin-right: 3px;
    }

    .travellInfo--item span{
        display: inline-block;
        vertical-align: middle;
    }

    .travellInfo--clock img{
        width: 16px;
        height:16px;
    }
    .travellInfo--ship img{
        width:23px;
        height:14px;
    }
    .travellInfo--date img{
        width:15px;
        height:16px;
    }
    .travellInfo--days img{
        width: 18px;
        height:18px;
    }
    .travellInfo--location img{
        width:19px;
        height:13px;
    }
    .travellInfo--clockTxt,span.travellInfo--shipTxt,
    .travellInfo--dateTxt,.travellInfo--daysTxt,
    .travellInfo--locationTxt{
        color:#666;
        margin-left: 5px;
    }

    .travellInfo--clockTxt {
        color: #999;
    }

    a.travellInfo--shipTxt {
        text-decoration: underline;
    }

    .travellInfo--sorts{
        clear: both;
        margin-top:10px;
    }
    .item--sorts{
        display: inline-block;
        color: #999;
        background:#eeeff1;
        padding:6px 14px;
        border-radius:14px;
        margin-right: 10px;
    }

    .travelRoutine {
        width: 100%;
        background-color: #fff;
        box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
    }

    .travelRoutine.onTop {
        position: fixed;
        top: 0;
        z-index:111;
    }

    .travellingDiary__outline {
        clear: both;
        overflow: hidden;
        background-color: #fff;
    }

    .outline--leftCon{
        width:120px;
        float: left;
        text-align: center;
        margin-top:14px;
    }
    .outline--leftPic img{
        width:34px;
        height:34px;
    }
    .outline--leftTitle{
        font-size: 18px;
        color:#000f57;
        margin-top:16px;
    }
    .outline--arrowPic{
        float: left;
    }
    .outline--rightCon{
        width: 81%;
        float: left;
        margin-left:4%;
        position:relative;
    }

    .item--content{
        width:100%;
        background:#fff;
        margin-top:22px;
        padding:28px 20px;
        border-radius: 6px;
        box-shadow:1px 2px 5px rgba(0, 0, 0, 0.3);
    }
    .item--title p{
        font-size: 18px;
        color:#000f57;
    }
    .item--divideLine{
        height:1px;
        background: #e5e5e5;
        margin:0 -20px;
        margin-top:26px;
    }
    .item--body{
        margin-top:28px;
        line-height: 25px;
    }
    .item--body p{
        color: #666;
    }
    .item--body >>> img{
        display: block;
        width: 680px;
        height: auto;
        margin:0 auto;
    }

    /*选择菜单*/
    .item--listMenu{
        width:100%;
        height:80px;
        line-height:80px;
        background:#fff;
        margin-top:22px;
        padding:0 20px;
        border-radius: 6px;
        box-shadow:1px 2px 5px rgba(0, 0, 0, 0.3);
        font-size: 12px;
        text-align: center;
        overflow: hidden;
    }
    .item--preDiray{
        float: left;
        display: inline-block;
        width:350px;
        height:80px;
        text-align:left;
    }
    .item--preDiray img {
        margin-left: 3px;
    }
    .item--listDiray{
        width:134px;
        text-align: center;
        display: inline-block;
        border-left: 1px solid #e5e5e5;
        border-right: 1px solid #e5e5e5;
        cursor: pointer;
    }
    .item--nextDiray{
        float: right;
        display: inline-block;
        width:350px;
        height:80px;
        text-align:right;
    }
    .item--nextDiray img{
        margin-left: 3px;
    }
    .item--returnList{
        color: #1174b8;
        vertical-align: middle;
    }
    .item--txt{
        color: #999;
    }
    .item--dirayName{
        color: #1174b8;
        display: inline;
        margin-left: 5px;
    }

    .travellingDiary__divideLine{
        width:100%;
        height:1px;
        background: #e5e5e5;
        margin-top:28px;
    }
    /* 下载模板 */
    .downloadTemplet {
        color:#FFF !important;
        font-size:19px;
    }
    /* 点赞 */
    .praiseCon {
        width:100%;
        background:#fff;
        margin-top:22px;
        padding:28px 20px;
        border-radius: 6px;
        box-shadow:1px 2px 5px rgba(0, 0, 0, 0.3);
        text-align:center;
    }
    .praiseOpe {
        display:inline-block;
        vertical-align:middle;
        margin-right:10px;
    }
    .praiseOpe img {
        display: none;
    }
    .praiseOpe .grey-icon{
        display: block;
    }
    .praiseOpe:hover .cur-icon, .praiseOpe.cur .cur-icon{
        display: block;
    }
    .praiseOpe:hover .grey-icon, .praiseOpe.cur .grey-icon{
        display: none;
    }
    .praiseCon p {
        display: inline-block;
        vertical-align: middle;
    }
    .praiseNumber {
        margin:0;
        font-size:18px;
        color:#000;
        font-weight:400;
        display:inline-block;
    }
    .praisePicBtn {
        width:60px;
        height:60px;
        cursor:pointer;
    }
    .praiseTxt {
        margin: 0;
        font-size:18px;
        color:#000;
        font-weight:400;
        display:inline-block;
    }
    /*点赞悬停*/
    .praiseCon .praiseOpe .praisePicBtn:hover{
        -webkit-transform:scale(1.20,1.20);
        -moz-transform:scale(1.20,1.20);
        -o-transform:scale(1.20,1.20);
        transform:scale(1.20,1.20);
        -webkit-transition: all 0.5s ease-out;
        -moz-transition: all 0.5s ease-out;
        -o-transition: all 0.5s ease-out;
        transition: all 0.5s ease-out;
    }

    .travelRoutine.onTop >>> .outline--item {
        padding: 20px 0;
    }
    .travelRoutine.onTop .outline--leftCon {
        margin-top:4px;
    }
    .travelRoutine.onTop .outline--arrowPic {
        height: 70px;
    }
    .travelRoutine.onTop .outline--arrowPic img {
        height: 100%;
    }
</style>
